<div class="bg-base-100 px-4 py-6 sm:px-6 lg:px-10">
  <header class="app-page-chrome mb-8 justify-end">
    <a
      [routerLink]="['/admin', 'home']"
      class="brand-chip no-underline"
    >
      <app-logo class="brand-chip-mark" [clickable]="false"></app-logo>
      <span class="brand-chip-label whitespace-nowrap">
        Kekeno Surveys
      </span>
    </a>
  </header>

  <main
    class="flex items-center justify-center py-4 sm:py-8 lg:py-10"
    [ngClass]="mainClass"
  >
    <section
      class="w-full overflow-hidden rounded-[16px] border border-textbox-border bg-surface-background"
      [ngClass]="panelClass"
    >
      <ng-content></ng-content>
    </section>
  </main>
</div>
